/* Como um `agent_id` se chama na tela.
 *
 * Morava em `routes/Reports.tsx`, e passou a ser compartilhado quando o Margin Finder
 * também virou dirigido pelos agentes descobertos na tabela — duas telas lendo mapas
 * separados divergiriam no primeiro agente novo.
 *
 * O fallback é o que faz "automático" valer para o agente SEGUINTE: um
 * `agent_previdencia` que apareça amanhã ganha a chip "Previdência" sem deploy. O id
 * exato não se perde — `Provenancia` imprime `<code>{agentId}</code>` verbatim. */

import { tituloBloco } from "./humano";

const AGENT_LABELS: Record<string, string> = {
  agent_profile: "Perfil",
  agent_telecom: "Telecom",
  agent_seguros: "Seguros",
  agent_saude: "Saúde",
  agent_assinaturas: "Assinaturas",
  agent_custo_financeiro: "Custo financeiro",
};

export const agentLabel = (id: string): string =>
  AGENT_LABELS[id] ?? tituloBloco(id.replace(/^agent[_-]/, ""));
